import { useState } from "react";

import MissingDataBanner from "components/MissingDataBanner";
import Box from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";

import { OpenTofuMigrationContext } from "./context";
import DashboardWidgetsOpenTofuMigrationDeprecationBanner from "./components/DeprecationBanner";
import DashboardWidgetsOpenTofuMigrationEmpty from "./components/Empty";
import DashboardWidgetsOpenTofuMigrationQueueList from "./components/QueueList";
import DashboardWidgetsOpenTofuMigrationReadyToMigrateList from "./components/ReadyToMigrateList";
import DashboardWidgetsOpenTofuMigrationTiles from "./components/Tiles";
import { OpenTofuMigrationTile } from "./types";

const DashboardWidgetsOpenTofuMigration = () => {
  const [selectedTile, setSelectedTile] = useState(OpenTofuMigrationTile.ReadyToMigrate);

  const { eligibleToMigrate, queuedToMigrate, isLoading, isEmpty, error, refetch } =
    useTypedContext(OpenTofuMigrationContext);

  if (error) {
    return (
      <MissingDataBanner
        text="Couldn’t load OpenTofu migration data. Please try to refresh or come back later."
        refreshHandler={refetch}
        fullWidth
      />
    );
  }

  if (isEmpty) {
    return <DashboardWidgetsOpenTofuMigrationEmpty />;
  }

  return (
    <Box direction="column" gap="large" fullWidth>
      <DashboardWidgetsOpenTofuMigrationDeprecationBanner />

      <DashboardWidgetsOpenTofuMigrationTiles
        eligibleToMigrate={eligibleToMigrate}
        queuedToMigrate={queuedToMigrate}
        isLoading={isLoading}
        selectedTile={selectedTile}
        onSelect={setSelectedTile}
      />

      {selectedTile === OpenTofuMigrationTile.ReadyToMigrate && (
        <DashboardWidgetsOpenTofuMigrationReadyToMigrateList />
      )}
      {selectedTile === OpenTofuMigrationTile.Queue && (
        <DashboardWidgetsOpenTofuMigrationQueueList queuedToMigrate={queuedToMigrate} />
      )}
    </Box>
  );
};

export default DashboardWidgetsOpenTofuMigration;
